import { useEffect, useState } from "react";
import config  from "../config";
import getData from "../common/getData";
import { useKeycloak } from "@react-keycloak/web";
import useApiError from "./useApiError";

const usersURL = `${config.app.apiBaseUrl}chatbots/v1/ChatUsers/GetByEmail?Email=`;

function useGetUserAuth(userEmail){
    const [userAuth, setUserAuth] = useState({exists: null, isBlocked: null, code: 200});
    const { keycloak } = useKeycloak();
    const { addError } = useApiError();

    useEffect(
        function () {
            async function init() {
                if (!keycloak?.token) return;
                if(!userEmail) return;

                let url = usersURL + userEmail;
                let auth = {exists: false, isBlocked: true, code: ""}

                let bearerToken = keycloak.token;

                try {
                    let data = await getData(bearerToken, url, "json", false);
                    if(data.status === 404){
                        auth = {...auth, exists: false, code: 404};
                    } else {
                        auth = {...auth, exists: true};
                    }

                    let containsBlocked = Object.hasOwn(data,'is-blocked')

                    if(containsBlocked){
                      if(data && data["is-blocked"] === true){
                          auth = {...auth, isBlocked: true, code: 403};
                      } else { 
                          auth = {...auth, isBlocked: false};
                      }
                    }
                    
                    setUserAuth(auth)
                } catch (err){
                    addError(`LOAD_DATA_ERROR: ${err}`, err);
                }
            }
            init();
        },
        // eslint-disable-next-line
        [userEmail, keycloak?.token]
    );
    return userAuth;
}

export default useGetUserAuth;